/* The header bag's moment and the Add to bag button's answer (snippets/bag-button.liquid; styles in
   sections/header.liquid). The Interactopus cart does the adding; this file watches it and answers:
   - the tapped button says "Adding" at once, then "Added" with a drawn check the moment Shopify
     confirms (Shopify takes ~0.65 s to accept an add on this store; nothing before this said so);
   - the header setting "After a piece is added" decides the rest: open the cart right away, play the
     bag moment and then open the cart, or play the moment and stay. To keep that timing, this file
     switches off the cart's own "Open when adding" and opens it through window.InteractopusCart;
   - if the shopper's own add is refused (sold out, too many: 422), the cart opens either way;
   - the count follows every change the cart reports, including + and - inside the cart;
   - when the header bag is scrolled out of view, a copy drops in at the top corner for the moment.
   One controller per page: the theme editor re-renders the header when a setting changes, so the
   bag, its look and the choices are read from the page when they are needed.
   Nothing here adds, removes or prices anything. */
(() => {
  if (window.__voissonBag) { window.__voissonBag.rescan(); return; }
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const OUT = 'cubic-bezier(.16,1,.3,1)';
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const S = { count: 0, lastCart: null, pending: null, takeover: false, addedText: '', hooked: false, openOnCart: false, moments: 0, cartWaiters: [] };
  const now = () => {
    const bags = [...document.querySelectorAll('[data-bag]')];
    const first = bags[0] || null;
    const a = first && first.dataset.bagAfter;
    return { bags, first, look: (first && first.dataset.bagLook) || 'ticker', after: a === 'stay' || a === 'open' ? a : 'drawer' };
  };
  const rescan = () => { const { first } = now(); if (first) { S.count = Number(first.dataset.bagCount) || 0; if (S.lastCart) { S.count = Number(S.lastCart.item_count) || 0; syncAll(S.count); } } };
  window.__voissonBag = { rescan };
  S.count = Number((now().first || { dataset: {} }).dataset.bagCount) || 0;
  document.addEventListener('shopify:section:load', rescan);

  /* 1. Take over "Open when adding". This script is deferred in the header and so runs before the
        cart's own deferred script, rendered at the end of the page. If the cart is already running,
        its switch is left alone and the header never opens it a second time. */
  const cfgNode = document.querySelector('script[type="application/json"][data-io-cart-config]');
  if (cfgNode && !window.InteractopusCart) {
    try {
      const cfg = JSON.parse(cfgNode.textContent);
      if (cfg && cfg.s && typeof cfg.s === 'object') { cfg.s.auto = false; cfgNode.textContent = JSON.stringify(cfg); S.takeover = true; }
      if (cfg && cfg.t && typeof cfg.t.added === 'string') S.addedText = cfg.t.added;
    } catch (e) { S.takeover = false; }
  }
  const cartState = () => { try { return (window.InteractopusCart && window.InteractopusCart.state()) || {}; } catch (e) { return {}; } };
  const openCart = () => { try { if (window.InteractopusCart) window.InteractopusCart.open(); } catch (e) { /* the cart handles itself */ } };
  /* Only while this file switched the cart's own opening off AND the Interactopus cart is the one in
     charge (it stands down for another cart app, or after handing a failed add back to the theme). */
  const mayOpen = () => S.takeover && !!cartState().takeover;
  const fresh = () => (S.pending && Date.now() - S.pending.at < 12000 ? S.pending : null);

  /* 2. The Add to bag button: a layer over it says Adding, then Added with a check. The button keeps
        its own text (the theme rewrites it when the shopper picks another option). Small buttons
        (card quick-adds) keep their own look. */
  const labels = () => { const f = now().first; return { adding: (f && f.dataset.adding) || 'Adding', added: (f && f.dataset.added) || 'Added' }; };
  const btnReset = (btn) => {
    const st = btn && btn._atc; if (!st) return;
    clearTimeout(st.t); st.layer.remove();
    btn.classList.remove('atc-on', 'atc-adding', 'atc-added', 'atc-leaving'); btn.removeAttribute('aria-busy'); btn._atc = null;
  };
  const btnAdding = (btn) => {
    if (!btn || btn.tagName !== 'BUTTON' || btn.getBoundingClientRect().width < 120) return;
    btnReset(btn);
    const layer = document.createElement('span');
    layer.className = 'atc-layer'; layer.setAttribute('aria-hidden', 'true');
    layer.innerHTML = '<svg class="atc-check" viewBox="0 0 24 24" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg><span class="atc-label"></span><span class="atc-bar"></span>';
    layer.querySelector('.atc-label').textContent = labels().adding;
    btn.classList.add('atc-host', 'atc-on', 'atc-adding'); btn.setAttribute('aria-busy', 'true'); btn.appendChild(layer);
    btn._atc = { layer, t: setTimeout(() => btnReset(btn), 10000) };
  };
  const btnAdded = (btn) => {
    const st = btn && btn._atc; if (!st) return;
    clearTimeout(st.t);
    st.layer.querySelector('.atc-label').textContent = labels().added;
    btn.classList.remove('atc-adding'); void btn.offsetWidth; btn.classList.add('atc-added'); btn.removeAttribute('aria-busy');
    st.t = setTimeout(() => { btn.classList.add('atc-leaving'); st.t = setTimeout(() => btnReset(btn), reduce ? 0 : 280); }, 1500);
  };

  /* 3. The shopper's own add: remember the form (its photo flies, its variant names the line, its
        quantity moves the number) and answer on the button at once. Window capture runs before the
        cart's document-level listener, which stops the event. */
  const photoFor = (form) => {
    const scope = form.closest('.io-card, [data-product-card], .product-card, li, article') || form.closest('section, main') || document;
    return [...scope.querySelectorAll('img')].find((img) => {
      const r = img.getBoundingClientRect();
      return r.width > 60 && r.height > 60 && r.bottom > 0 && r.top < innerHeight;
    }) || null;
  };
  addEventListener('submit', (e) => {
    const f = e.target;
    if (!f || f.nodeName !== 'FORM' || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    let variant = null, qty = 1;
    try { const d = new FormData(f); variant = String(d.get('id') || '') || null; qty = Math.max(1, Number(d.get('quantity')) || 1); } catch (err) { /* defaults */ }
    const btn = e.submitter || f.querySelector('[type="submit"], button:not([type])');
    const pend = { img: photoFor(f), variant, qty, btn, at: Date.now(), sent: false };
    S.pending = pend;
    btnAdding(btn);
    /* Nobody sent it (another script cancelled the submit): let the button go. */
    setTimeout(() => { if (!pend.sent && S.pending === pend) { S.pending = null; btnReset(btn); } }, 1500);
  }, true);
  /* Choosing another option rewrites the button's text; drop the layer first so it never goes blank. */
  document.addEventListener('change', (e) => {
    const f = e.target && e.target.closest && e.target.closest('form');
    if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) f.querySelectorAll('button').forEach(btnReset);
  }, true);

  /* 4. Watch the cart's add request. Its answer, not the cart's later re-read, starts everything.
        The cart asks Shopify to redraw a "cart-icon-bubble" section this theme does not have (about
        0.12 s of Shopify's time, for nothing); that one request field is dropped when no such element
        exists. The response itself is returned untouched. */
  if (typeof window.fetch === 'function') {
    const original = window.fetch;
    window.fetch = function (input, init) {
      let url = '';
      try {
        url = String((input && (input.url || input.href)) || input || '');
        if (/\/cart\/add(\.js)?(?:[?#]|$)/.test(url) && init && typeof FormData !== 'undefined' && init.body instanceof FormData &&
            init.body.get('sections') === 'cart-icon-bubble' && !document.getElementById('cart-icon-bubble')) init.body.delete('sections');
      } catch (e) { /* never in the way of the request */ }
      /* The shopper's form travels as FormData; gifts, pairs and steppers send JSON. The answer is bound
         to the request that carried her form, never to whichever add answers next. */
      let src = null;
      try {
        if (/\/cart\/add(\.js)?(?:[?#]|$)/.test(url) && init && typeof FormData !== 'undefined' && init.body instanceof FormData) {
          src = fresh();
          if (src) { src.sent = true; S.pending = null; }
        }
      } catch (e) { src = null; }
      const p = original.apply(this, arguments);
      if (src) {
        p.then((r) => {
          if (r.ok) r.clone().json().then((j) => confirmed(src, j), () => failed(src, 0));
          else failed(src, r.status);
        }, () => failed(src, 0));
      }
      return p;
    };
  }

  /* 5. Motion helpers */
  const roll = (odo, value) => {
    const old = odo.lastElementChild;
    if (old && old.textContent === String(value)) return;
    const nw = document.createElement('span');
    nw.className = 'bag__digit'; nw.textContent = value; odo.appendChild(nw);
    if (reduce || !old || !old.animate) { if (old) old.remove(); return; }
    const a = old.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-100%)', opacity: 0 }], { duration: 380, easing: OUT });
    a.onfinish = a.oncancel = () => old.remove();
    nw.animate([{ transform: 'translateY(100%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 440, easing: OUT });
  };
  const done = (anim) => new Promise((res) => { if (!anim) return res(); anim.onfinish = anim.oncancel = () => res(); });
  const bump = (el, frames) => { if (!reduce && el && el.animate) el.animate(frames, { duration: 540, easing: 'ease-out' }); };
  const fly = (img, target) => {
    if (reduce || !img || !target || !img.animate) return Promise.resolve();
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) return Promise.resolve();
    const c = img.cloneNode(false);
    c.removeAttribute('loading'); c.removeAttribute('srcset'); c.removeAttribute('sizes'); c.removeAttribute('id');
    c.src = img.currentSrc || img.src; c.alt = ''; c.className = 'bag-flyer';
    Object.assign(c.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.appendChild(c);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const cx = dx * 0.92, cy = dy * 0.12, s1 = 8 / a.width, frames = [];
    for (let i = 0; i <= 16; i++) {
      const t = i / 16, u = 1 - t;
      frames.push({ offset: t, transform: `translate(${2 * u * t * cx + t * t * dx}px,${2 * u * t * cy + t * t * dy}px) scale(${1 + (s1 - 1) * Math.pow(t, 1.4)})`, opacity: t < 0.84 ? 1 : 1 - (t - 0.84) * 3 });
    }
    return done(c.animate(frames, { duration: 700, easing: 'cubic-bezier(.45,0,.2,1)', fill: 'forwards' })).then(() => c.remove());
  };
  const setCount = (bag, n) => {
    bag.classList.toggle('is-empty', n === 0);
    bag.classList.toggle('has-large-count', n > 99);
    const word = bag.querySelector('.bag__word');
    bag.setAttribute('aria-label', (word ? word.textContent : 'Bag') + (n ? ` (${n})` : ''));
    bag.dataset.bagCount = n;
    bag.querySelectorAll('.bag__odo').forEach((odo) => roll(odo, odo.closest('.bag__sq') && n > 99 ? '99+' : n));
  };
  const syncAll = (n) => now().bags.forEach((b) => setCount(b, n));

  /* 6. The three moments. Each resolves when the shopper has seen the piece arrive; the number they
        write is the live one, never a number captured before a later change. */
  const statusFor = (bag) => (bag.closest('.bag-float') ? bag.closest('.bag-float').querySelector('.bag-status') : document.querySelector('[data-bag-status]'));
  const MOMENTS = {
    async ticker(bag, item) {
      setCount(bag, S.count);
      const line = bag.querySelector('.bag__line');
      if (line && !reduce && line.animate) line.animate([{ transform: 'scaleX(0)', transformOrigin: 'left' }, { transform: 'scaleX(1)', transformOrigin: 'left', offset: 0.4 }, { transform: 'scaleX(1)', transformOrigin: 'right', offset: 0.7 }, { transform: 'scaleX(0)', transformOrigin: 'right' }], { duration: 1500, easing: 'cubic-bezier(.65,0,.35,1)' });
      const st = statusFor(bag);
      if (st && item && item.title) {
        st.textContent = S.addedText ? S.addedText.replace(/\{\{\s*title\s*\}\}/g, () => item.title) : item.title;
        st.classList.remove('is-leaving'); st.hidden = false;
        clearTimeout(st._t);
        st._t = setTimeout(() => { st.classList.add('is-leaving'); st._t = setTimeout(() => { st.hidden = true; }, 300); }, 2600);
      }
      await wait(reduce ? 0 : 650);
    },
    async ring_box(bag, item, img) {
      const lid = bag.querySelector('.bag__lid'), box = bag.querySelector('.bag__box'), glint = bag.querySelector('.bag__glint');
      const moving = !reduce && lid && lid.animate;
      const open = moving ? lid.animate([{ transform: 'none' }, { transform: 'translate(0,-2px) rotate(-28deg)' }], { duration: 280, easing: OUT, fill: 'forwards' }) : null;
      await fly(img, box);
      if (moving) {
        await done(lid.animate([{ transform: 'translate(0,-2px) rotate(-28deg)' }, { transform: 'translate(0,.6px) rotate(3deg)', offset: 0.6 }, { transform: 'none' }], { duration: 300, easing: 'ease-in' }));
        if (open) open.cancel();
        bump(box, [{ transform: 'scale(1,1)' }, { transform: 'scale(1.1,.88)', offset: 0.3 }, { transform: 'scale(.96,1.05)', offset: 0.65 }, { transform: 'scale(1,1)' }]);
        if (glint) glint.animate([{ opacity: 0, transform: 'scale(.2) rotate(0)' }, { opacity: 1, transform: 'scale(1.25) rotate(45deg)', offset: 0.4 }, { opacity: 0, transform: 'scale(.5) rotate(90deg)' }], { duration: 640, easing: 'ease-out' });
      }
      setCount(bag, S.count);
      await wait(reduce ? 0 : 250);
    },
    async glint(bag) {
      const sparks = bag.querySelectorAll('.bag__spark'), icon = bag.querySelector('.bag__gem svg');
      if (!reduce && bag.animate) {
        const K = [{ opacity: 0, transform: 'scale(.1) rotate(0)' }, { opacity: 1, transform: 'scale(1) rotate(45deg)', offset: 0.35 }, { opacity: 0, transform: 'scale(.3) rotate(130deg)' }];
        if (sparks[0]) sparks[0].animate(K, { duration: 780, easing: 'cubic-bezier(.2,.8,.2,1)' });
        if (sparks[1]) sparks[1].animate(K, { duration: 620, delay: 170, easing: 'cubic-bezier(.2,.8,.2,1)' });
        if (icon) icon.animate([{ fill: 'rgba(234,222,217,0)' }, { fill: 'rgba(234,222,217,1)', offset: 0.3 }, { fill: 'rgba(234,222,217,0)' }], { duration: 1000 });
        bump(bag.querySelector('.bag__gem'), [{ transform: 'scale(1)' }, { transform: 'scale(1.18)', offset: 0.35 }, { transform: 'scale(.95)', offset: 0.7 }, { transform: 'scale(1)' }]);
      }
      const sq = bag.querySelector('.bag__sq');
      const wasEmpty = bag.classList.contains('is-empty');
      setCount(bag, S.count);
      if (!reduce && sq && wasEmpty && sq.animate) sq.animate([{ transform: 'scale(0)' }, { transform: 'scale(1.3)', offset: 0.6 }, { transform: 'scale(1)' }], { duration: 440, easing: 'ease-out' });
      await wait(reduce ? 0 : 800);
    },
  };

  /* A bag the shopper can see, or a copy of it dropped in at the top corner for the moment. */
  const visible = (el) => { const r = el.getBoundingClientRect(); return r.width > 0 && r.bottom > 8 && r.top < innerHeight - 8 && getComputedStyle(el).visibility !== 'hidden'; };
  const stage = async (look) => {
    const { bags, first } = now();
    const shown = bags.find(visible);
    if (shown || !first) return { bag: shown || null, leave: async () => {} };
    const holder = document.createElement('div');
    holder.className = 'bag-float';
    holder.setAttribute('aria-hidden', 'true');
    const copy = first.cloneNode(true);
    copy.removeAttribute('href'); copy.setAttribute('tabindex', '-1'); copy.removeAttribute('data-bag'); copy.removeAttribute('data-cart-link');
    const row = document.createElement('div'); row.className = 'bag-float__row';
    const logo = document.querySelector('[data-header] .voisson-logo');
    if (logo) { const mark = logo.cloneNode(true); mark.removeAttribute('id'); mark.setAttribute('aria-hidden', 'true'); row.appendChild(mark); }
    row.appendChild(copy); holder.appendChild(row);
    if (look === 'ticker') { const st = document.createElement('p'); st.className = 'bag-status'; st.hidden = true; holder.appendChild(st); }
    document.body.appendChild(holder);
    if (!reduce && holder.animate) await done(holder.animate([{ transform: 'translateY(-130%)' }, { transform: 'none' }], { duration: 380, easing: OUT }));
    return {
      bag: copy,
      leave: async () => {
        await wait(reduce ? 900 : 1500);
        if (!reduce && holder.animate) await done(holder.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(-130%)', opacity: 0 }], { duration: 320, easing: 'ease-in', fill: 'forwards' }));
        holder.remove();
      },
    };
  };

  /* 7. Shopify confirmed the shopper's add. */
  const waitCart = (ms) => new Promise((res) => { const t = setTimeout(res, ms); S.cartWaiters.push(() => { clearTimeout(t); res(); }); });
  let playing = Promise.resolve();
  function confirmed(src, j) {
    if (S.pending === src) S.pending = null;
    btnAdded(src.btn);
    const line = j && (j.items && j.items.length ? j.items.find((i) => String(i.variant_id || i.id) === src.variant) || j.items[0] : j);
    const item = { title: (line && (line.product_title || line.title)) || '' };
    S.count += src.qty;
    const { look, after } = now();
    if (after === 'open' && S.takeover) {
      syncAll(S.count);
      S.openOnCart = Date.now(); /* opened on the cart's re-read, so it shows the new line */
      return;
    }
    const cartSeen = waitCart(2500);
    S.moments += 1;
    playing = playing.then(async () => {
      let leave = null;
      try {
        const st = await stage(look);
        leave = st.leave;
        if (st.bag && MOMENTS[look]) {
          try { window.__voissonHeader?.celebrate?.(st.bag); } catch (e) { /* motion never interrupts the cart */ }
          await MOMENTS[look](st.bag, item, src.img);
        }
      } finally {
        await cartSeen;
        S.moments -= 1;
        syncAll(S.count);
        if (after === 'drawer' && mayOpen()) openCart();
        if (leave) leave();
      }
    }).catch(() => { syncAll(S.count); });
  }
  function failed(src, status) {
    if (S.pending === src) S.pending = null;
    btnReset(src.btn);
    if (status === 422 && mayOpen()) setTimeout(openCart, 60);
  }

  /* 8. Every cart change the cart reports: the number follows it. */
  const onCart = (cart) => {
    if (!cart || typeof cart !== 'object') return;
    S.lastCart = cart;
    S.count = Number(cart.item_count) || 0;
    S.cartWaiters.splice(0).forEach((f) => f());
    if (S.openOnCart) {
      const due = Date.now() - S.openOnCart < 3000;
      S.openOnCart = false;
      if (due) { syncAll(S.count); if (mayOpen()) openCart(); return; }
    }
    if (!S.moments) syncAll(S.count);
  };
  const hook = () => {
    if (S.hooked) return true;
    if (!window.InteractopusCart || typeof window.InteractopusCart.on !== 'function') return false;
    window.InteractopusCart.on('cart', onCart);
    const c = window.InteractopusCart.cart && window.InteractopusCart.cart();
    if (c) { S.lastCart = c; const n = Number(c.item_count) || 0; if (n !== S.count) { S.count = n; syncAll(n); } }
    S.hooked = true;
    return true;
  };
  if (!hook()) {
    document.addEventListener('DOMContentLoaded', hook, { once: true });
    let tries = 0;
    const t = setInterval(() => { if (hook() || ++tries > 40) clearInterval(t); }, 250);
  }
  /* A page shown from the browser's memory or a prerender can carry an old count: ask the cart. */
  const resync = () => {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null)).then((c) => { if (c) { S.lastCart = c; S.count = Number(c.item_count) || 0; syncAll(S.count); } }).catch(() => {});
  };
  addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    S.pending = null; S.openOnCart = false;
    document.querySelectorAll('.atc-on').forEach(btnReset);
    resync();
  });
  document.addEventListener('prerenderingchange', resync, { once: true });
  /* 8. "Goes together" added two pieces through its own request: play the same after-add choice. */
  document.addEventListener('interactopus:cart:added', (e) => { e.preventDefault(); confirmed({ img: null, variant: null, qty: (e.detail.lines || []).reduce((n, l) => n + (Number(l.quantity) || 1), 0), btn: null, at: Date.now(), sent: true }, e.detail.answer); });
})();
